module.exports = __webpack_public_path__ + "img/img11.ad85ae67.png";